import BadgerAccordion from 'badger-accordion';
import { throttle } from 'throttle-debounce';
import $ from '../lib/jquery';


import { Component } from '../core/component';

export class Accordion extends Component {
    selector = '.js-accordion';

    init() {
        const accordions = this.$elements.toArray().map((element) => {
            return new BadgerAccordion(element, {
                headerClass: '.js-accordion-header',
                panelClass: '.js-accordion-panel',
                panelInnerClass: '.js-accordion-panel-inner',
                hiddenClass: 'is-hidden',
                activeClass: 'is-active',
                initializedClass: 'is-initialized',
            });
        });

        $(window).on('resize', throttle(250, () => {
            accordions.forEach((accordion) => {
                accordion.calculateAllPanelsHeight();
            });
        }));
    }
}



// WEBPACK FOOTER //
// ./assets/js/components/Accordion.js